module.exports = __webpack_public_path__ + "static/media/img88.4aabfef9.jpg";